module.exports = __webpack_public_path__ + "img/数据清洗select.2f3b9879.svg";